import { Attr, BelongsTo, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { EmailDeliverySender, Nullable } from "shared/types";

import type EmailDomain from "./EmailDomain";
import type StreamNotification from "./StreamNotification";

@Model()
class StreamNotificationSpecification extends ApplicationRecord {
  static jsonapiType = "stream_notification_specifications";

  @Attr() customSender: string;

  @HasOne() emailDomain: EmailDomain;

  @Attr() emailDomainId: Nullable<number>;

  @Attr() includeAiSummary: boolean;

  @Attr() sender: EmailDeliverySender;

  @Attr() senderEmail: string;

  @Attr() senderName: string;

  @BelongsTo() streamNotification: StreamNotification;
}

export default StreamNotificationSpecification;
